import $ from 'jquery';

interface Opts {
  headingSelector: string;
  bodySelector: string;
  blockSelector: string;
  expandedClassToggle: string;
}

function initializeExpansionField(opts: Opts) {
  const blocks = document.querySelectorAll(opts.blockSelector);

  blocks.forEach((block) => {
    const heading = block.querySelector<HTMLElement>(opts.headingSelector);
    const body = block.querySelector<HTMLElement>(opts.bodySelector);

    if (!heading || !body) {
      console.warn('Expansion block missing heading or body');
      return;
    }

    function setExpanded(expanded: boolean) {
      if (!body) {
        return;
      }
      block.classList.toggle(opts.expandedClassToggle, expanded);
      body.style.maxHeight = expanded ? `${body.scrollHeight}px` : '0';
      body.setAttribute('aria-hidden', expanded ? 'false' : 'true');
      heading?.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    heading.addEventListener('click', () => {
      const expanded = block.classList.contains(opts.expandedClassToggle);
      setExpanded(!expanded);
    });
  });
}

/**
 * Initialize accordions for event program section
 */
export default function initializeExpansionFields() {
  initializeExpansionField({
    blockSelector: '.gksblock-expansionBlock',
    headingSelector: '.gksblock-expansionBlock-heading',
    bodySelector: '.gksblock-expansionBlock-body',
    expandedClassToggle: 'gksblock-expansionBlock--expanded',
  });

  initializeExpansionField({
    blockSelector: '.block--expansionBlock',
    headingSelector: '.block-expansionBlock-heading',
    bodySelector: '.block-expansionBlock-body',
    expandedClassToggle: 'block--expansionBlock--expanded',
  });
}
